import React, { useEffect, useRef, useState } from 'react';
import { components } from 'react-select';
import PropTypes from 'prop-types';
import {EiqSelectCheckbox} from 'eiq-storybook';
import s from './SelectBox.styles';

const OptionWithDefinition = ({ data, ...rest }) => {
  const [expandedDefinition, setExpandedDefinition] = useState(false);
  const [optionWidth, setOptionWidth] = useState(null);
  const optionWrapperRef = useRef(null);

  useEffect(() => {
    const optionWidthValue = optionWrapperRef?.current?.getBoundingClientRect()?.width || null;
    setOptionWidth(optionWidthValue);
  }, [optionWrapperRef?.current]);
  
  return (
    <components.Option {...rest}>
      <s.OptionWithSubTextContainer ref={optionWrapperRef}>
        {rest.isMulti && <EiqSelectCheckbox isMulti={rest.isMulti} isSelected={rest.isSelected} /> }
        <span>{data.label} <br/>
          {expandedDefinition && <s.OptionSubText>{data.subText}</s.OptionSubText>}
        </span>
        {(optionWidth && data.subText) && <s.OptionExpander
          onClick={(e) => {
            e.stopPropagation();
            setExpandedDefinition(!expandedDefinition);
          }}
          optionWidth={optionWidth}>
          <s.OptionExpanderText>Definition</s.OptionExpanderText>
          <s.OptionExpanderIcon expandedDefinition={expandedDefinition}/>
        </s.OptionExpander>}
      </s.OptionWithSubTextContainer>
    </components.Option>
  );
};

OptionWithDefinition.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string,
    subText: PropTypes.string,
  }),
};

export default React.memo(OptionWithDefinition);
